




































































































import Vue from "vue";
import Component from "vue-class-component";
import { IVueStateCollection } from "@/ts/FormBuilder";
import func from "@/ts/FormFunctions";
import fieldData from "@/ts/FormData";
import api from "@/ts/functions";
import ReportingPeriod from '@/views/reporting/ReportingPeriod.vue';
import AddressInfo from '@/views/shared/AddressInfo.vue';
import ContactInfo from '@/views/shared/ContactInfo.vue';
import ErrorMessages from "@/ts/constants/ReportingErrorMessages";
import { ILiquidHazardousWasteVueModel } from "@/ts/models/ILiquidHazardousWasteVueModel";
import VueSimpleSuggest from 'vue-simple-suggest/dist/cjs';

@Component({
    props: {
        form: {
            type: Object as () => ILiquidHazardousWasteVueModel
        },
        vueStates: {
            type: Object as () => IVueStateCollection
        },
        isReadOnly: {
            type: Boolean
        }
    },
    components: {
        AddressInfo, ContactInfo, VueSimpleSuggest, ReportingPeriod
    }
})
export default class LiquidHazardousWasteFacilityInfo extends Vue {
    name: string = "LiquidHazardousWasteFacilityInfo";
    title: string = "";

    errorMsgs = ErrorMessages;
    hasAddressError: boolean = false;
    hasContactError: boolean = false;
    facilities: any = null;
    disableFacility: boolean = true;
    facilitiesDb: any = null;

    facility: any = null;

    mounted() {
        this.title = this.$props.vueStates.views[0].name;

        this.$emit("update:title", this.title);
        this.$emit("update:currentIndex", 0);

        api.getFacilities("Liquid Hazardous Waste")
            .then(res => {
                this.facilitiesDb = res;
                this.facilitiesDb = this.facilitiesDb.data;
                this.facilities = this.facilitiesDb.map((f: any) => f.facilityName);
                this.facilities = this.facilities.map(Function.prototype.call, String.prototype.trim);
            });

        this.$watch("hasErrors", (n, o) => {
            this.$props.vueStates.views[0].error = this.hasErrors;
        }, { immediate: true });

        this.$props.vueStates.views[0].visited = true;

        this.$props.form.generatorStatus = "N/A";

        this.$watch("form.facilityNameSelect", (n, o) => {
            if (this.facilitiesDb == null) {
                return;
            }

            var objectId = this.$props.form.facilityNameSelect.substring(this.$props.form.facilityNameSelect.lastIndexOf('-') + 2);
            
            var facilityAddress = null;
            this.facility = this.facilitiesDb.find((f: any) => f.objectId == objectId);
            
            if (this.facility == null) {
                facilityAddress = fieldData.emptyAddress[0];
            } else {
                facilityAddress = this.facility.address;
                this.$props.form.facilityName = this.facility.facilityName;
                this.$props.form.lhwGeneratorId = this.facility.lhwGeneratorId == undefined ? 'N/A' : this.facility.lhwGeneratorId.trim();
                this.$props.form.lhwGeneratorStatus = this.facility.lwhGeneratorStatus == undefined ? 'N/A' : this.facility.lwhGeneratorStatus;
            }
            if (facilityAddress != null) {
                this.$props.form.facilityAddress = facilityAddress;
                if (facilityAddress != fieldData.emptyAddress[0] && this.facility != null) {
                    this.$props.form.facilityId = this.facility.objectId;     
                    this.$props.form.facilityRefId = this.facility.facilityId;
                }
            } else {
                //this.$props.form.facilityAddress = fieldData.emptyAddress[0];
            }
        }, { immediate: true });
    }

    get isGeneratorStatusError(): boolean {
        return func.isNullOrEmpty(this.$props.form.generatorStatus);
    }

    get isGeneratorIdError(): boolean {
        return func.isNullOrEmpty(this.$props.form.lhwGeneratorId);
    }

    get isFacilityNameError(): boolean {
        return func.isNullOrEmpty(this.$props.form.facilityName)
    }

    get isReportingYearError(): boolean {
        return this.$props.form.reportingPeriod == null && this.$props.form.reportingYear == null
    }
    
    get hasErrors(): boolean {
        return this.isFacilityNameError || this.hasAddressError || this.isGeneratorIdError || this.isReportingYearError;
    }
}
